module.exports = {"350925100":"狮城镇","350925101":"咸村镇","350925102":"浦源镇","350925103":"七步镇","350925104":"李墩镇","350925105":"纯池镇","350925200":"泗桥乡","350925201":"礼门乡","350925202":"玛坑乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/350925.json
// module id = 1354
// module chunks = 0